<template>
    <div class="flex b:1|solid|#CECECE r:20 w:414 max-w:100%" :class="main ? 'p:22|32' : 'p:16'">
        <div class="flex:1 flex flex-direction:column jc:space-between f:14 gap:14">
            <div class="flex gap:16">
                <div class="w:94">
                    <span class="inline-flex ai:center p:4|8"><span class="w:18 h:18 bg:url(image/index/search/icon_comment.svg) mr:4"></span>整體評價</span>
                </div>
                <div class="flex:1 flex ai:center">
                    <star-rating-input-pure :model-value="info.ratings.total" @update:model-value="(value) => info.setRating('total', value)"></star-rating-input-pure>
                </div>
                <div class="w:78 flex ai:center {color:primary}_input:checked+label">
                    <input @change="(value) => info.setNoRating('total', value)" :checked="info.no_ratings.total" class="form-check-input m:0|12|0|8! w:16! h:16!" :id="`${id}1`" type="checkbox">
                    <label class="form-check-label font-weight:700" :for="`${id}1`">不拘</label>
                </div>
            </div>
            <div class="flex gap:16">
                <div class="w:94 flex ai:center">
                    <span class="inline-flex ai:center p:4|8 w:70"><span class="w:18 h:18 bg:url(image/index/search/icon_candy.svg) mr:4"></span>甜度</span>
                    <tooltip class="w:20 h:20 bg:url(image/index/search/icon_circle_info.svg) bg:no-repeat" data-placement="top" title="給分高低"></tooltip>
                </div>
                <div class="flex:1 flex ai:center">
                    <star-rating-input-pure :model-value="info.ratings.score" @update:model-value="(value) => info.setRating('score', value)"></star-rating-input-pure>
                </div>
                <div class="w:78 flex ai:center {color:primary}_input:checked+label">
                    <input @change="(value) => info.setNoRating('score', value)" :checked="info.no_ratings.score" class="form-check-input m:0|12|0|8! w:16! h:16!" :id="`${id}2`" type="checkbox">
                    <label class="form-check-label font-weight:700" :for="`${id}2`">不拘</label>
                </div>
            </div>
            <div class="flex gap:16">
                <div class="w:94 flex ai:center">
                    <span class="inline-flex ai:center p:4|8 w:70"><span class="w:18 h:18 bg:url(image/index/search/icon_cool.svg) mr:4"></span>涼度</span>
                    <tooltip class="w:20 h:20 bg:url(image/index/search/icon_circle_info.svg) bg:no-repeat" data-placement="top" title="輕鬆程度"></tooltip>
                </div>
                <div class="flex:1 flex ai:center">
                    <star-rating-input-pure :model-value="info.ratings.easy" @update:model-value="(value) => info.setRating('easy', value)"></star-rating-input-pure>
                </div>
                <div class="w:78 flex ai:center {color:primary}_input:checked+label">
                    <input @change="(value) => info.setNoRating('easy', value)" :checked="info.no_ratings.easy" class="form-check-input m:0|12|0|8! w:16! h:16!" :id="`${id}3`" type="checkbox">
                    <label class="form-check-label font-weight:700" :for="`${id}3`">不拘</label>
                </div>
            </div>
            <div class="flex gap:16">
                <div class="w:94 flex ai:center">
                    <span class="inline-flex ai:center p:4|8 w:70"><span class="w:18 h:18 bg:url(image/index/search/icon_happy.svg) mr:4"></span>CP值</span>
                    <tooltip class="w:20 h:20 bg:url(image/index/search/icon_circle_info.svg) bg:no-repeat" data-placement="top" title="課程含金量"></tooltip>
                </div>
                <div class="flex:1 flex ai:center">
                    <star-rating-input-pure :model-value="info.ratings.content" @update:model-value="(value) => info.setRating('content', value)"></star-rating-input-pure>
                </div>
                <div class="w:78 flex ai:center {color:primary}_input:checked+label">
                    <input @change="(value) => info.setNoRating('content', value)" :checked="info.no_ratings.content" class="form-check-input m:0|12|0|8! w:16! h:16!" :id="`${id}4`" type="checkbox">
                    <label class="form-check-label font-weight:700" :for="`${id}4`">不拘</label>
                </div>
            </div>
            <div class="flex gap:16">
                <div class="w:94">
                    <span class="inline-flex ai:center p:4|8"><span class="w:18 h:18 bg:url(image/index/search/icon_teacher.svg) mr:4"></span>老師評價</span>
                </div>
                <div class="flex:1 flex ai:center">
                    <star-rating-input-pure :model-value="info.ratings.professor" @update:model-value="(value) => info.setRating('professor', value)"></star-rating-input-pure>
                </div>
                <div class="w:78 flex ai:center {color:primary}_input:checked+label">
                    <input @change="(value) => info.setNoRating('professor', value)" :checked="info.no_ratings.professor" class="form-check-input m:0|12|0|8! w:16! h:16!" :id="`${id}5`" type="checkbox">
                    <label class="form-check-label font-weight:700" :for="`${id}5`">不拘</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const id = nextId();

    const info = useSearchInfo();

    defineProps({
        main: { default: false, type: Boolean }
    });
</script>
